import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IInstitution } from '../types/interfaces/IInstitution';

export async function getInstitutions(): Promise<ApiResponse<IInstitution[]>> {
  return apiClient.get<IInstitution[]>('/institutions');
}

export async function getInstitutionById(
  id: string
): Promise<ApiResponse<IInstitution | null>> {
  return apiClient.get<IInstitution | null>(`/institutions/${id}`);
}

export async function createInstitution(
  data: Omit<IInstitution, 'id' | 'createdAt' | 'updatedAt'>
): Promise<ApiResponse<IInstitution>> {
  return apiClient.post<IInstitution>('/institutions', data);
}

export async function updateInstitution(
  id: string,
  data: Partial<IInstitution>
): Promise<ApiResponse<IInstitution | null>> {
  return apiClient.put<IInstitution | null>(`/institutions/${id}`, data);
}

export async function deleteInstitution(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/institutions/${id}`);
}

export async function toggleInstitutionStatus(
  id: string
): Promise<ApiResponse<IInstitution>> {
  return apiClient.patch<IInstitution>(`/institutions/${id}/toggle-status`);
}
